export default __webpack_public_path__ + "static/media/ed2mit2021tuto_A02-big-data-platforms-v02.fb583215.pdf";